import { Component, Input, OnInit, OnDestroy, HostBinding, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import swal from 'sweetalert2';
import { BillingService } from '../../../services/billing.service';
import { getParamFromAncestorRoute, getQueryParamFromAncestorRoute } from '../../../utilities/route.utilities';


@Component({
    selector: 'average-consumption-grid-item',
    templateUrl: './average-consumption-grid-item.component.html',
})
export class AverageConsumptionGridItemComponent implements AfterViewInit, OnDestroy {

    subscriptions: any[] = [];
    timePeriod: number = 1;
    clientId: number;
    siteId: number;
    averageConsumption: any[] = [];
    hasData: boolean = false;
    hasLoading: boolean = true;

    constructor(
        private billingService: BillingService,
        private route: ActivatedRoute,
        private router: Router) {
    }

    ngAfterViewInit(): void {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    onInitialise() {
        this.clientId = getParamFromAncestorRoute(this.route, 'clientId');
        this.timePeriod = getQueryParamFromAncestorRoute(this.route, 'timePeriod');
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    onInfoClick() {
        swal({
            title: 'Average daily consumption',
            html: '<p style="text-align: left;">This widget shows the average daily consumption by supply, either on a daily or monthly view.</p>\
            <p style="text-align: left;">The shaded area represents where the majority (90%) of your meters fall having excluded the top and bottom 5%.</p>\
            <p style="text-align: left;">The average daily consumption considers all meters including the outliers excluded as above.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
